"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = require("../icon");

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Button = function Button(props) {
  return /*#__PURE__*/_react.default.createElement("button", _extends({}, props, {
    type: "button",
    style: props.style,
    className: ['shpmtc-button', "shpmtc-button--".concat(props.size === 'default' || props.size === null ? 'medium' : props.size), "shpmtc-button--".concat(props.type === '' || props.type === 'default' ? 'default' : props.type), props.className].join(' '),
    disabled: props.disabled,
    onClick: props.onClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-button__content"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "shpmtc-button__content__text"
  }, props.children), props.type === 'Dropdown' ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    type: "shpmtcdicon-arrow-down"
  }) : null));
};

exports.Button = Button;
Button.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  type: _propTypes.default.string,
  size: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  onClick: _propTypes.default.func
};
Button.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  type: '',
  size: null,
  style: null,
  onClick: null
};